import AgentPresence from 'src/models/AgentPresence';
import createDocumentResource from 'src/actions/shared/createDocumentResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';
import * as sharedTypes from 'src/actions/shared/sharedTypes';

const agentPresenceResource = createDocumentResource<any>({
  name: 'agentPresence',
  endpoint: 'v1/orgs/:orgId/agents/:agentId/presence',
  observerCreator: emptyObserverCreator,
});

const set: sharedTypes.AppThunk = (agentPresence: AgentPresence) => async dispatch => {
  dispatch(agentPresenceResource.effects.replace({}, agentPresence, { doNotShowToast: true }));
};

agentPresenceResource.effects.set = set;

export default agentPresenceResource;
